exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* 主色 */\n\n/* Light Primary 常用于 hover */\n\n/* Dark Primary 常用于 active */\n\n/* 主文本 常用于 ·标题 */\n\n/* 主文本 常用于 ·详情/按钮 */\n\n/* 常用于 ·侧边栏/顶部栏·导览·详情表格信息文本 */\n\n/* 次文本 常用于 ·底部分页栏 */\n\n/* 次文本 常用于 ·输入文本/框/线 */\n\n/* 常用于 ·滑动按钮底色 */\n\n/* 常用于 ·卡片操作栏底色 */\n\n/* 常用于 ·背景色/表格 */\n\n/* 常用于信息提示 */\n\n/* 常用于信息提示 */\n\n/* 常用于成功 */\n\n/* 常用于成功 */\n\n/* 常用于警告 */\n\n/* 常用于警告 */\n\n/* 常用于失败 */\n\n/* 常用于失败 */\n.i-link {\n  cursor: pointer;\n}\n.i-link-color,\n.i-link-color:hover,\n.i-link-color:active {\n  color: inherit;\n}", ""]);

// exports
